import { render, staticRenderFns } from "./idcardExample.vue?vue&type=template&id=bbd47316&scoped=true"
import script from "./idcardExample.vue?vue&type=script&lang=js"
export * from "./idcardExample.vue?vue&type=script&lang=js"
import style0 from "./idcardExample.vue?vue&type=style&index=0&id=bbd47316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd47316",
  null
  
)

export default component.exports